module.exports = __webpack_public_path__ + "static/gs1-sm-e7a6e2e94bf6782bee806c75a74d5d63.jpg";